import axios, { AxiosInstance } from "axios";
import { setupCache, buildMemoryStorage } from "axios-cache-interceptor";

export interface Params {
  [key: string]: string;
}

const storage = buildMemoryStorage();

class APIService {
  url: string;
  header: Params;
  api: AxiosInstance;
  constructor(url: string, header: Params) {
    this.url = url;
    this.header = header;
    this.api = axios.create({
      withCredentials: true,
      headers: header,
    });
    setupCache(this.api, { storage });
  }
  get(params?: Params | any, options?: Params | any) {
    const res = this.api.get(this.url, { params: params });
    return res;
  }
}
export default APIService;
